import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmployeeMatch } from '@app/pages/profile/skill-person-matches/match-list/match-list.types';
import { UUID } from '@app/_api/identifyable';
import { EmployeeExperienceDto } from '@app/_api/dto';
import { BaseApi } from '@app/core/services/api/base.api';
import { ToastService } from '@app/core/services/toast.service';
import { DialogService } from '@app/core/services/dialog.service';
import { SkillAssignmentCore } from '@app/core/model/skill-assignment-core';

@Service()
export class SkillAssignmentCoreApi extends BaseApi {
  constructor() {
    const http = inject(HttpClient);
    const toastService = inject(ToastService);
    const dialog = inject(DialogService);

    super(http, '/skill-assignment-core', toastService, dialog);
  }

  // foreign tree view
  fetchAll(employeeId?: UUID) {
    return super.GET<SkillAssignmentCore[]>(``, employeeId ? { params: { employeeId } } : undefined);
  }

  // skill persons list
  fetchBySkillId(skillId: UUID, config: { onlyPreview: boolean }): Observable<EmployeeExperienceDto[]> {
    return super.GET<EmployeeExperienceDto[]>(`/persons/${skillId}`, { params: { onlyTop5: config.onlyPreview } });
  }

  // profile matches
  fetchAllBySkillAndDepartmentIds(skillIds: UUID[], departmentIds: UUID[]) {
    return super.GET<EmployeeMatch[]>(`/persons/matching`, { params: { skillIds, departmentIds } });
  }
}
